import { createSlice } from "@reduxjs/toolkit";
const minSize = process.env.REACT_APP_MIN_SIZE
const maxSize = process.env.REACT_APP_MAX_SIZE

const initialState = {
  data: null,
  landType : ["Construction", "Land Parcel"],
  selectedType: {"Construction":true, "Land Parcel":true},
  selectMinMaxOfSize:[minSize, maxSize],
  showSidebar: false,
  loading: false,
  error: null,
};

const selectedVillageDetails = createSlice({
  name: "selectedVillageDetails",
  initialState,
  reducers: {
    fetchSelectedVillageDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    setSidebarVisibility(state, action) {
        state.showSidebar = action.payload === true;
    },
    fetchSelectedVillageDetailsSuccess(state, action) {
      console.log("fetchDataSuccess selectedVillageDetails success");
      state.loading = false;
      
      const tempData = action.payload;
      state.data = tempData;
      console.log("selectedVillageDetails are ", state.data)
      console.log("fetchDataSuccess selectedVillageDetails success data");
    },
    selectLandType(state, action){
      state.loading = false;
      state.selectedType = {
        ...state.selectedType,
        ...action.payload,
      };
    },
    setSelectMinMaxOfSize(state, action){
      state.loading = false;
      state.selectMinMaxOfSize = {
        ...state.selectMinMaxOfSize,
        ...action.payload,
      };
    },
    fetchSelectedVillageDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSelectedVillageDetailsStart,
  setSidebarVisibility,
  fetchSelectedVillageDetailsSuccess,
  fetchSelectedVillageDetailsFailure,
  selectLandType,
  setSelectMinMaxOfSize
} = selectedVillageDetails.actions;
export default selectedVillageDetails.reducer;
